module.exports = __webpack_public_path__ + "img/verification.32987f3d.svg";